import React from 'react';
import {Atom, withSystem, withMeta, Plugins} from '@packages/systems/wfdl';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {checkoutInputStyle, mobileCheckoutInputStyle} from './styles';

import {TBoolean, TText, TEnum} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';
import {
  getBooleanOrElse,
  getInPojo,
  getString,
  getStringOrElse,
} from '@packages/utilities/data-utils';

const CommerceCheckoutAdditionalTextInput = Atom.createRender(
  ({attributes, classes, data, context, generateAttributes}) => {
    const name = getStringOrElse(getInPojo(data, ['name']), '');
    const type = getStringOrElse(getInPojo(data, ['type']), 'text');
    const required = getBooleanOrElse(getInPojo(data, ['required']), false);
    const placeholder = getString(getInPojo(data, ['placeholder']));
    const isIncluded = context.get('includeTextInput', true);

    return isIncluded ? (
      <input
        {...generateAttributes(attributes, classes)}
        name={name}
        type={type}
        placeholder={placeholder}
        maxLength={256}
        required={required}
      />
    ) : null;
  }
);

const config = createIntegratedAtom({
  displayName: 'Text Field',
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Form'), iconName('Input')),
  },
  showEmpty: false,
  style: {
    base: {
      main: checkoutInputStyle,
      tiny: mobileCheckoutInputStyle,
    },
  },
  constraints: {
    ancestors: [
      {is: 'CommerceCheckoutAdditionalInputsContainer', rule: 'ExactlyOne'},
    ],
  },
  render: CommerceCheckoutAdditionalTextInput,
  fields: {
    name: withSystem(
      {
        label: 'Name',
        defaultValue: 'Telephone',
      },
      TText
    ),
    placeholder: withSystem(
      {
        label: 'Placeholder',
        defaultValue: 'Enter telephone number...',
      },
      TText
    ),
    type: withMeta(
      {
        variant: 'menu',
      },
      withSystem(
        {
          label: 'Text type',
          defaultValue: 'tel',
        },
        TEnum({
          text: 'Plain',
          email: 'Email',
          password: 'Password',
          tel: 'Phone',
          number: 'Number',
        })
      )
    ),
    required: withSystem({label: 'Required', defaultValue: false}, TBoolean),
  },
});

export default config;
